import React from 'react';
import { Switch } from '@headlessui/react';

interface PricingToggleProps {
  isYearly: boolean;
  onToggle: () => void;
}

const PricingToggle: React.FC<PricingToggleProps> = ({ isYearly, onToggle }) => {
  return (
    <div className="flex items-center justify-center space-x-4">
      <span className={`text-sm font-medium ${!isYearly ? 'text-gray-900' : 'text-gray-500'}`}>
        Monthly
      </span>
      
      <Switch
        checked={isYearly}
        onChange={onToggle}
        className={`
          ${isYearly ? 'bg-airbnb-red' : 'bg-gray-200'}
          relative inline-flex h-6 w-11
          items-center rounded-full
          transition-colors duration-200 ease-in-out
          focus:outline-none focus:ring-2 focus:ring-airbnb-red focus:ring-offset-2
        `}
      >
        <span
          className={`
            ${isYearly ? 'translate-x-6' : 'translate-x-1'}
            inline-block h-4 w-4 transform rounded-full
            bg-white transition duration-200 ease-in-out
          `}
        />
      </Switch>
      
      <span className={`text-sm font-medium ${isYearly ? 'text-gray-900' : 'text-gray-500'}`}>
        Yearly
        <span className="ml-1.5 text-xs bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
          Save 20%
        </span>
      </span>
    </div>
  );
};

export default PricingToggle;